<template>
  <div class="common-com">
    <div class="search">
      <!-- <Y-input
        :placeholder="databaseFields"
        :input.sync="search"
        :style="{ marginRight: '10px' }"
      /> -->
      <div style="display: flex; align-items: center;">
        <el-input v-model="search" size="small" :placeholder="this.$t('listOfSet.databaseFields')"
          @keyup.enter.native="handleEnter"></el-input>
        <el-select v-if="sheetdisabled" size="small" clearable v-model="sheetid" :placeholder="$t('FormOfSet.sheet')">
          <el-option v-for="(item, index) in sheetidoptions" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="dataDict" size="small" :placeholder="this.$t('listOfSet.dataDict')" @keyup.enter.native="handleEnter"></el-input>
        <el-button style="margin: 0 10px 0 0" size="mini" type="primary" :style="{ fontSize: fonts }"
          @click="handleClickButton('find')">{{ $t("configMoudle.search") }}</el-button>
        <el-button v-if="$route.path === '/system/formSet'" style="margin: 0 10px 0 0" size="mini" type="primary" :style="{ fontSize: fonts }"
          @click="handleClickButton('toKey')">{{ $t("configMoudle.copyTokey") }}</el-button>
        <el-button v-if="$route.path === '/system/keySet'" style="margin: 0 10px 0 0" size="mini" type="primary" :style="{ fontSize: fonts }"
          @click="handleClickButton('toFrom')">{{ $t("configMoudle.copyToform") }}</el-button>
      </div>
    </div>
    <Y-button :button="button" @handleClickButton="handleClickButton" style="margin-bottom: 10px"/>
    <Y-table
      v-loading="loading"
      :column="column"
      :tableData="tableData"
      :row-class-name="changeRowClassName"
      :alingitem="'alignType'"
      :handleBtn="handleBtn"
      editCell
      @handleClickHandle="handleClickHandle"
      :index="false"
      :style="{ height: '100%' }"
    >
      <template #myColumn="{ row, column, $index }">
        <!-- {{column}} -->
        <Y-input v-if="!column.type" :input.sync="row[column['prop']]"
          :ref="`y-input-${column['prop']}`" @blur="handleBlur(row, column['prop'])"></Y-input>
        <el-input v-if="column.type == 'textarea'" type="textarea" :rows="2"
          v-model="row[column['prop']]" @blur="handleBlur(row, column['prop'])"></el-input>
        <el-input v-if="column.type == 'number'" type="number"
          v-model="row[column['prop']]" @blur="handleBlur(row, column['prop'])"></el-input>
        <el-select size="mini" v-model="row[column['prop']]" clearable v-if="column.type === 'select' && !column.multiple"
          :value-key="column.optionValue" :filterable="column.filterable" @change="handleChange(row, $event, column)">
          <el-option v-for="val in column.list" :key="`${val[column.optionValue || 'value'] || val}-select-option`"
            :value="column.optionValue ? val : val[column.optionValue || 'value'] || val"
            :label="val[column.optionLabel || 'label'] || val"></el-option>
        </el-select>
        <el-select v-model="row[column['prop']]" clearable multiple collapse-tags :value-key="column.optionValue"
          v-if="column.type === 'select' && column.multiple" @change="handleChange(row, row[column['prop']], column)">
          <el-option :label="$t('Emails.getAll')" value="all"></el-option>
          <el-option :label="$t('Emails.clearAll')" value="empty"></el-option>
          <el-option v-for="val in column.list" :key="`${val[column.optionValue || 'value'] || val}-select-option`"
            :value="column.optionValue ? val : val[column.optionValue || 'value'] || val"
            :label="val[column.optionLabel || 'label'] || val"></el-option>
        </el-select>
        <!-- switch -->
        <!-- filterProp(row.fieldName) 屏蔽字段所属行不显示开关控件 -->
        <el-switch
          v-if="column.type == 'switch' && filterProp(row.fieldName)"
          v-model="row[column['prop']]"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="handleBlur(row)"
        >
        </el-switch>
      </template>
    </Y-table>
    <!-- :height="'calc(100% - 400px)'" -->
    <Y-page
      v-if="total >= 0"
      :total="total"
      :currentPage="page.pageNum"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />
    <Y-dialog :dialog.sync="dialog" :destoryOnClone="false" :title="dialogTitle" @handleOk="handleOk">
      <Y-form :form="copyColumn" :formData="formData" inline @handleSelect="handleSelect" @languageData="languageData"/>
      <div style="font-size: 18px;line-height: 24px;color: #303133;margin:10px 0 20px 0;" v-if="isString">表单校验规则设定</div>
      <Y-form :form="copyColumnOne" :formData="formDataOne" inline @handleSelect="handleSelect" @languageData="languageData"/>
    </Y-dialog>

    <Y-dialog :dialog.sync="formulaDialog" width="40%" :destoryOnClone="false"
      :title="$t('configMoudle.formulaEditor')" @handleOk="handleOkFormula" @update:dialog="handleCloseFormula">
      <div style="display: flex;font-size: 15px;margin-bottom: 15px;">
        <div style="width: 50%;">{{$t('configMoudle.resultField')}}: {{ formulaInfo.itemName }}</div>
        <div>{{$t('configMoudle.fieldType')}}: {{ formulaInfo.dataName }}</div>
      </div>
      <div>
        <el-select v-model="filedName" :placeholder="$t('configMoudle.selectfieldName')" style="margin-right: 15px"
          @change="(val) => handleChangeField(val)" size="small">
          <el-option-group v-for="group in formularList" :key="group.header" :label="group.header">
            <el-option v-for="item in group.itemList" :key="item.itemName" :label="item.itemShowName" :value="item.id">
            </el-option>
          </el-option-group>
          <!-- <template v-for="(item, index) in formularList">
            <el-option :value="item.itemName" :label="item.itemShowName" :key="index"></el-option>
          </template> -->
        </el-select>
        <el-select v-model="operator" :placeholder="$t('configMoudle.operator')" style="margin-right: 15px" size="small"
          @change="handleChangeOperator">
          <template v-for="(item, index) in operatorOption">
            <el-option :key="index" :value="item.value" :label="item.label"></el-option>
          </template>
        </el-select>
        <el-select v-model="funValue" :placeholder="$t('configMoudle.function')" @change="handleChangeFun" size="small">
          <template v-for="(item, index) in funOption">
            <el-option :key="index" :value="item.value" :label="item.label"></el-option>
          </template>
        </el-select>
        <el-button type="primary" @click="handleResetFormula" size="small">{{$t('configMoudle.clear')}}</el-button>
      </div>
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :placeholder="$t('placeHolder.expression')" v-model="formulaShowTemplate"
        v-if="formulaShowTemplate !== ''" style="margin: 10px 0 0 0" @input="handleTemplateInput"></el-input>
    </Y-dialog>
  </div>
</template>

<script>
import * as Api from "@/api/sysTem/index";
import { checkFont } from "@/utils/methods";
import {
  sheetsConfigrequest,
  getFormulaById,
  submitFormulaInfo,
  getFormulaByFieldId,
  getFormulaList,
} from "@/api/sysTem/index";
import { copyToform, copyTokey } from "@/api/sysTem/listSet";
import { dataType } from "@/assets/js/table";
import clone from "clone";
export default {
  props: {
    button: Array,
    column: Array,
    columnOne: Array,
    api: String,
    LanguageSet: Number,
    comDataId: String,
    routePath: String,
    isStringTitle: Boolean
  },
  data() {
    return {
      tableData: [],
      dialog: false,
      formData: null,
      formDataOne: null,
      languageDatas: [],
      dialogTitle: "",
      page: {
        pageSize: 20,
        pageNum: 1,
      },
      id: null,
      total: 0,
      search: "",
      dataDict: "",
      searchData: "",
      sheetid: "",
      sheetidoptions: [],
      sheetdisabled: false,
      showForRoles: "",
      Row: "",
      handleBtn: [
        { class: "el-icon-edit", key: "edit", title: this.$t("listOfSet.edit") },
        { class: "el-icon-delete", key: "delete", title: this.$t("listOfSet.delete") },
        { class: "el-icon-cpu", key: "Language", title: this.$t("listOfSet.language") },
        { class: "el-icon-s-grid", key: "coding", title: this.$t("Menu.codeSet") },
      ],
      databaseFields: this.$t("listOfSet.databaseFields"),
      searchButton: [{ key: "find", label: this.$t("listOfSet.search") }],
      fonts: null,
      loading: false,
      copyColumn: [],
      copyColumnOne: [],
      formulaDialog: false,
      formulaInfo: {},
      formularList: [],
      filedName: "",
      operator: null,
      operatorOption: [
        { value: 1, label: "+" },
        { value: 2, label: "-" },
        { value: 3, label: "*" },
        { value: 4, label: "/" },
      ],
      funOption: [
        { value: 1, label: "sum()" },
        { value: 2, label: "min()" },
        { value: 3, label: "max()" },
        { value: 4, label: "avg()" },
      ],
      funValue: null,
      formulaShowTemplate: "",
      formulaTemplate: "",
      formulaId: null,
      dataId: '',
      dataRoutePath: '',
      isString: null
    };
  },
  computed: {
    // dialogTitle() {
    //   return this.formData && JSON.stringify(this.formData) !== "{}"
    //     ? "编辑"
    //     : "新增";
    // },
    curApi() {
      let t = Object.prototype.hasOwnProperty.call(Api, this.api);
      return t ? Api[this.api] : "";
    },
  },
  created() {
    if (this.$route.path === "/system/formSet" || this.dataRoutePath === '/system/formSet') {
      this.sheetdisabled = true;
      this.sheetsConfigfunction();
      if (this.$route.query.id || this.dataId) {
        this.handleBtn.push({ class: "el-icon-film", key: "configFormula", title: this.$t("listOfSet.configFormula") });
      }
    } else {
      this.sheetdisabled = false;
    }
    // if (this.LanguageSet && this.LanguageSet != "" && this.LanguageSet !== null && this.LanguageSet !== undefined) {
    //   if(getSession('LanguageName') == 'en') {
    //     this.handleBtn.push({ class: "el-icon-cpu", key: "Language", title: this.$t('listOfSet.language') })
    //   } else this.handleBtn.push({ class: "el-icon-cpu", key: "Language", title: this.$t('listOfSet.language') })
    // }
    this.id = this.$route.query.id || this.dataId;
    if (!this.id) return;
    this.curApi && this.init();

    // if (this.$route.name == 'keySet') {
    //   this.handleBtn.splice(2, 1)
    // }
    // 如果增加去掉这句话，表单设置所属sheet页的标题内容切换成别的模块的表单设置内容就会不见
    this.$route.meta.keepAlive = false;
    // 语言切换
    // this.getLanguage()
  },

  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.formData = {};
        this.formDataOne = {}
        // 对话框状态为关闭时，还原copyColumn的初始值
        this.copyColumn = clone(this.column);
        this.copyColumnOne = clone(this.columnOne)
      }
    },
    comDataId: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    },
    routePath: {
      handler(newVal, oldVal) {
        this.dataRoutePath = newVal
      }, deep: true, immediate: true
    },
    isStringTitle: {
      handler(newVal, oldVal) {
        this.isString = newVal
      }, deep: true, immediate: true
    }
  },
  activated() {
    let closeTagList = this.$store.state.global.tagCloseRouteList;
    if (closeTagList && closeTagList.length > 0) {
      if (closeTagList.indexOf(this.$route.fullPath) != -1) {
        this.$store.commit("global/DEL_TAG_CLEAR_CATCH", this.$route.fullPath);
        // this.search = ''
        // this.searchData = ''
        // this.page = {
        //   pageNum: 1,
        //   pageSize: 20
        // }
      }
    }
    this.search = "";
    this.dataDict = "";
    this.searchData = "";
    this.page = {
      pageNum: 1,
      pageSize: 20,
    };
    this.init(this.$route.query.id || this.dataId);
  },
  mounted() {
    let font = checkFont();
    this.fonts = font;
    // copyColumn用来存放column的深度克隆，用作修改对话框中的表单列表内容展示项
    this.copyColumn = clone(this.column);
    this.copyColumnOne = clone(this.columnOne)
  },
  methods: {
    //回车键触发搜索
    handleEnter() {
      this.handleClickButton("find");
    },
    sheetsConfigfunction() {
      sheetsConfigrequest({ formId: this.$route.query.id || this.dataId }).then((res) => {
        this.sheetidoptions = [];
        for (let i = 0; i < res.length; i++) {
          let data = {
            value: res[i].id,
            label: res[i].sheetName,
          };
          this.sheetidoptions.push(data);
        }
      });
    },
    init(id) {
      id ? (this.id = id) : "";
      const obj = {
        ...this.page,
        name: this.searchData,
        dataDict: this.dataDict,
        sheetid: this.sheetid,
        [this.$attrs.apiKey || "formId"]: this.id,
      };
      if (!this.id) return;
      this.loading = true;
      this.curApi({ method: "get", reqInfo: obj })
        .then((res) => {
          this.loading = false;
          const { result, totalRecord, pageNum } = res;
          if (result || totalRecord || pageNum) {
            result?.forEach((item) => {
              if (item.approveParam) {
                item.approveParam = true;
              } else if (item.approveParam == 0) {
                item.approveParam = false;
              }
            });
            this.total = totalRecord;
            this.page.pageNum = pageNum;
          } else {
            this.total = res.length;
          }
          this.tableData = result || res;
        })
        .catch((_) => (this.loading = false));
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.init();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.init();
    },
    handleClickHandle({ title, scope: { row } }) {
      switch (title) {
        case "edit":
          this.dialogTitle = this.$t("FetchSet.edit");
          this.dialog = true;
          this.copyColumn = clone(this.column);
          this.copyColumnOne = clone(this.columnOne);
          // 调取屏蔽特殊字段中包含当前行的fieldName字段时，将编辑对话框中的调取开关控件隐藏
          if (!this.filterProp(row.fieldName)) {
            this.copyColumn = this.copyColumn.filter(
              (item) => item.prop !== "isFetched"
            );
          }
          this.formData = clone(row);
          this.formDataOne = clone(row)
          break;
        case "delete":
          this.curApi({ method: "delete", id: row.id }).then((res) => {
            this.init();
          });
          break;
        // case "Language":
        //   this.$router.push({
        //     name: "LanguageSet",
        //     params: { id: row.id, type: this.LanguageSet },
        //   });
        //   break;
        // case "coding":
        //   this.$router.push({
        //     name: "codingSet",
        //     query: {
        //       fieldId: row.id,
        //       formId: row.formConfigId,
        //       fieldName: row.itemName,
        //       rowId: row.id,
        //     },
        //   });
        //   break;
        case "configFormula":
          this.formulaDialog = true;
          this.formulaInfo = row;
          const list = dataType();
          this.formulaInfo.dataName = list.find(
            (item) => item.value === this.formulaInfo.dataType
          ).label;
          // 获取当前模块下的字段数据
          getFormulaById(this.$route.query.id || this.dataId).then((res) => {
            this.formularList = res.map((item) => {
              if (item.itemList) {
                item.itemList = item.itemList.filter(
                  (item) =>
                    (item.dataType === 2 || item.dataType === 4) &&
                    item.itemShowName
                );
              }
              return item;
            });
          });
          getFormulaByFieldId({ type: 0, fieldId: row.id }).then((res) => {
            if (res) {
              this.formulaShowTemplate = res.showTemplate;
              this.formulaTemplate = res.template;
              this.formulaId = res.id || null;
            }
          });
          break;
        default:
          break;
      }
      this.$emit('handleClickHandle', title, row, this.LanguageSet)
    },
    handleOk(vnode = []) {
      const formDataOne = vnode[0].componentInstance.curData
      const formDataTwo = vnode[2].componentInstance.curData
      let formData = {...formDataOne, ...formDataTwo}
      formData['ruleMessageList'] = this.languageDatas
      const keyId = this.$attrs.apiKey || "formConfigId";
      formData.showForRoles = formData.showForRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      formData.readOnlyRoles = formData.readOnlyRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      if (formData.approveParam) {
        // 是否提交字段
        formData.approveParam = 1;
      } else if (
        formData.hasOwnProperty("approveParam") &&
        !formData.approveParam
      ) {
        formData.approveParam = 0;
      }
      // formData.approveParam为undefined
      if (this.dialogTitle == this.$t("FetchSet.add")) {
        this.curApi({  method: "post", reqInfo: { ...formData, [keyId]: this.id },}).then(() => {
          this.init();
        });
      }
      if (this.dialogTitle == this.$t("FetchSet.edit")) {
        this.curApi({ method: "put", reqInfo: { ...formData, [keyId]: this.id },}).then((res) => {
          this.init();
        });
      }
      this.dialog = false;
    },
    handleClickButton(val) {
      switch (val) {
        case "add":
          this.dialogTitle = this.$t("FetchSet.add");
          this.formData = {};
          let add = [];
          // slice()
          let newlist = this.tableData.slice();
          for (let i = 0; i < newlist.length; i++) {
            add.push(newlist[i].itemOrder);
          }
          let newadd = [];
          let itemOrderdd = 0;
          if (add.length == 0) {
            newadd = [];
            itemOrderdd = 1;
          } else {
            newadd = add.sort((x, y) => x - y);
            itemOrderdd = newadd[newadd.length - 1] * 1 + 1;
          }
          // if () {}
          // this.formData.filterType = 6
          this.formData.itemOrder = itemOrderdd;
          this.formData.id = "";
          this.dialog = true;
          break;
        case "find":
          this.page.pageNum = 1;
          this.searchData = this.search;
          this.init();
          break;
        case "toKey":
          copyTokey(this.$route.query.id || this.dataId).then((res) => {});
          break;
        case "toFrom":
          copyToform(this.$route.query.id || this.dataId).then((res) => {});
          break;
        default:
          break;
      }
    },
    changeRowClassName({ row, rowIndex }) {
      row.$index = rowIndex;
    },
    handleChange(row, val, list) {
      if (row.approveParam) {
        row.approveParam = 1;
      } else if (row.hasOwnProperty("approveParam") && !row.approveParam) {
        row.approveParam = 0;
      }
      row.showForRoles = row.showForRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      row.readOnlyRoles = row.readOnlyRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      // row.dicId = row.dicId?.map(item => ({
      //   dicId: item.id
      // }))
      if (list.prop === "dataType") {
        if (val === 3) {
          row.filterType = 9;
        } else if (val === 2) {
          row.filterType = 1;
        } else {
          row.filterType = 6;
        }
      }
      if (Array.isArray(val)) {
        let role = [];
        // 判断val值为全选或全不选时才执行
        for (let v of val) {
          // 全选时遍历赋值roleId
          if (v == "all") {
            for (let i of list.list) {
              role.push(i.roleId);
            }
            if (list.label == "可见") {
              row.showForRoles = role?.map((item) => ({
                roleId: item,
              }));
            } else if (list.label == "只读") {
              row.readOnlyRoles = role?.map((item) => ({
                roleId: item,
              }));
            }
          }
          // 全不选时清空row.showForRoles字段集合
          else if (v == "empty") {
            if (list.label == "可见") {
              row.showForRoles = [];
            } else if (list.label == "只读") {
              row.readOnlyRoles = [];
            }
          }
          // else {
          //   row.dicId = val
          // }
        }
      }
      // row.dicId = row.dicId?.id;
      // row.dicName = row.dicName?.id;
      const keyId = this.$attrs.apiKey || "formConfigId";
      delete row.$index;
      this.curApi({
        method: "put",
        reqInfo: {
          ...row,
          [keyId]: this.id,
        },
      }).then(() => {
        this.init();
      });
    },
    handleBlur(row, e, value) {
      if (row.formula) {
        this.formulaInfo = {
          ...row.formula,
          expressionDecimalDigit: row.expressionDecimalDigit,
        };
        this.formulaShowTemplate = row.showTemplate;
      }
      row.showForRoles = row.showForRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      row.readOnlyRoles = row.readOnlyRoles?.map((item) => ({
        roleId: item.roleId,
      }));
      if (row.approveParam) {
        row.approveParam = 1;
      } else if (row.hasOwnProperty("approveParam") && !row.approveParam) {
        row.approveParam = 0;
      }
      const keyId = this.$attrs.apiKey || "formConfigId";
      delete row.$index;
      this.curApi({
        method: "put",
        reqInfo: {
          ...row,
          [keyId]: this.id,
        },
      }).then(() => {
        if (e === "expressionDecimalDigit" && row.formula) {
          this.handleOkFormula();
        }
        this.init();
      });
    },
    handleBlurs() {},
    handleSelect(value, item, it) {
      if (item === "dataType") {
        if (value === 3) {
          it.filterType = 9;
        } else if (value === 2) {
          it.filterType = 1;
        } else {
          it.filterType = 6;
        }
      }
      this.$emit("handleSelect", value, item, it);
    },
    languageData(value) {
      this.languageDatas = value;
    },
    // // 切换语言
    // getLanguage() {
    //   if(getSession("LanguageName") == 'en') {
    //     this.databaseFields = 'databaseFields'                  // 数据库字段名
    //     this.searchButton = [{ key: 'find', label: 'search' }]  // 查找
    //   }
    // }

    filterProp(prop) {
      // 调取这个功能中，在代码中默认去掉几个目标模块字段的调取，这几个字段不管我在调取设置里有没有设置调取，这几个字段都不要调取。注意是目标模块，字段：（rid,del_flag,placed,process_instance_id,line,sys_template_name,fmodalid,fsaved）
      const arr = [
        "fmodalid",
        "rid",
        "del_flag",
        "placed",
        "process_instance_id",
        "line",
        "sys_template_name",
        "fsaved",
      ];
      const FilterTip = (field) => field !== prop;
      return arr.every(FilterTip);
    },
    /* 选择字段 */
    handleChangeField(val) {
      let name = "";
      let header = "";
      for (let i = 0; i <= this.formularList.length; i++) {
        if (
          this.formularList[i].itemList &&
          this.formularList[i].itemList.length !== 0
        ) {
          if (this.formularList[i].itemList.find((items) => items.id === val)) {
            const formConfigId = this.formularList[i].itemList.find(
              (items) => items.id === val
            ).formConfigId;
            name = this.formularList[i].itemList.find(
              (items) => items.id === val
            ).itemShowName;

            if (this.formularList[i].id === formConfigId) {
              header = this.formularList[i].header;
            }
            break;
          }
        }
      }
      if (name !== "") {
        if (this.formulaShowTemplate.indexOf("()") !== -1) {
          const index = this.formulaShowTemplate.indexOf("()") + 1;
          this.formulaShowTemplate =
            this.formulaShowTemplate.slice(0, index) +
            "【" +
            header +
            "." +
            name +
            "】" +
            this.formulaShowTemplate.slice(index);
        } else {
          this.formulaShowTemplate =
            this.formulaShowTemplate + "【" + header + "." + name + "】";
        }
      }
      this.filedName = null;
    },
    /* 运算符操作 */
    handleTemplateInput() {},
    /* 选择运算符 */
    handleChangeOperator(val) {
      const txt = this.operatorOption.find((item) => item.value === val).label;
      this.formulaShowTemplate = this.formulaShowTemplate + txt;
      this.operator = null;
      // this.formulaTemplate = this.formulaTemplate ? this.formulaTemplate + ',' + txt : this.formulaTemplate + txt
    },
    handleCloseFormula() {
      this.handleResetFormula();
    },
    /* 选择函数 */
    handleChangeFun(val) {
      const funTxt = this.funOption.find((item) => item.value === val).label;
      this.formulaShowTemplate = this.formulaShowTemplate + funTxt;
      this.funValue = null;
      // this.formulaTemplate = this.formulaTemplate ? this.formulaTemplate + ',' + funTxt : this.formulaTemplate + funTxt
    },
    /* 计算公式保存 */
    handleOkFormula() {
      let strOther = "";
      if (this.formulaShowTemplate) {
        const str = this.formulaShowTemplate.replaceAll("【", "");
        strOther = str.replaceAll("】", ")");
        this.formularList.forEach((item) => {
          if (item.id === this.$route.query.id || this.dataId) {
            strOther = strOther.replaceAll(item.header + ".", ".");
            item.itemList.forEach((items) => {
              strOther = strOther.replaceAll(
                "." + items.itemShowName + ")",
                items.itemName
              );
            });
          } else {
            if (item.parentId !== this.formularList[0].id) {
              strOther = strOther.replaceAll(
                item.header + ".",
                ".sub," + item.parentId + "," + item.id + ","
              );
              item.itemList.forEach((items) => {
                strOther = strOther.replaceAll(
                  "," + items.itemShowName + ")",
                  "," + items.itemName
                );
              });
            } else {
              strOther = strOther.replaceAll(item.header, item.id + ",");
              item.itemList.forEach((items) => {
                strOther = strOther.replaceAll(
                  ",." + items.itemShowName,
                  ",." + items.itemName
                );
              });
            }
          }
        });
        strOther = strOther.replaceAll("sum(", "sum,");
        strOther = strOther.replaceAll("max(", "max,");
        strOther = strOther.replaceAll("min(", "min,");
        strOther = strOther.replaceAll("avg(", "avg,");
        strOther = strOther.replaceAll(".", "");
        strOther = strOther.replaceAll("+", ",+,");
        strOther = strOther.replaceAll("-", ",-,");
        strOther = strOther.replaceAll("*", ",*,");
        strOther = strOther.replaceAll("/", ",/,");
        strOther = strOther.replaceAll("(", "(,");
        strOther = strOther.replaceAll(")", ",)");
      }
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(strOther)) {
        this.$message.error("表名或者字段名不符合");
        return;
      }
      const data = {
        dataType: this.formulaInfo.dataName,
        fieldName: this.formulaInfo.itemName,
        formConfigId: this.$route.query.id || this.dataId,
        showName: this.formulaInfo.itemShowName,
        template: strOther,
        showTemplate: this.formulaShowTemplate,
        fieldId: this.formulaInfo.id,
        type: 0,
        decimals: this.formulaInfo.expressionDecimalDigit,
      };
      submitFormulaInfo(data, this.formulaId).then((res) => {
        this.$message.success(this.$t("roleAdmin.tip5"));
        this.formulaDialog = false;
        this.formulaInfo = {};
        this.formulaId = null;
        this.handleResetFormula();
      });
    },
    /*  清空 */
    handleResetFormula() {
      this.filedName = null;
      this.operator = null;
      this.funValue = null;
      this.formulaShowTemplate = "";
      this.formulaTemplate = "";
    },
  },
};
</script>
<style scoped lang="scss">
.common-com {
  height: 100%;
  display: flex;
  flex-direction: column;

  .search {
    width: 100%;
    display: flex;
    margin: 10px 0;
  }
}

.el-input {
  width: 140px;
  margin-right: 10px;
}

.el-select {
  width: 140px;
  margin-right: 10px;
}
</style>
